<template>
  <!-- <Unity src="../../../public/TestToJS/index.html"></Unity> -->
  <div>
    <iframe style="height: 100vh; width: 100vw;"
            src="/unity/index.html" scrolling="0"
            ref="myIframe"
            @load="sendMessage"
            ></iframe>
  </div>
</template>

<script>
import { aesDecrypt } from './index.js'
let textureArray = []
export default {
    data(){
        return{

        }
    },
    mounted () {
        this.init()
        // this.$refs.myIframe.contentWindow.location.reload()
        // console.log(this.$refs.myIframe.contentWindow);
        // this.$refs.myIframe.contentWindow.postMessage({id:1,value:999}, '*');
        // console.log(myGameInstance);
        // window.addEventListener('unityEvent', this.unityWatch)
        // this.$once('hook:beforeDestroy',()=>{
        //     window.removeEventListener('unityEvent', this.unityWatch)
        // })
    },
    methods:{
        init(){
            let aboutModelArray = [
                'https://pgov.oss-cn-qingdao.aliyuncs.com/231205/419e0da561154e92b5b1df1f7559d4d0.fbx',
                'https://pgov.oss-cn-qingdao.aliyuncs.com/231205/150016472ee5425196b7abeb52f535fe.dds',
                'https://pgov.oss-cn-qingdao.aliyuncs.com/231205/9ab13a893aa74913b09a8a80ca1e7dc1.dds',
                'https://pgov.oss-cn-qingdao.aliyuncs.com/231205/13d4b16b93ae498c8b834072f8b10331.dds',
                'https://pgov.oss-cn-qingdao.aliyuncs.com/231205/3b01ad318a8e4bdb972b2189a47d645b.dds'
            ]
            aboutModelArray.forEach((item,index)=>{
                aesDecrypt(item).then((model)=>{
                    textureArray.push(model)
                })
            })
            // console.log('textureArray:',textureArray)
        },
        sendMessage() {
            // console.log(this.$refs.myIframe);
            this.$refs.myIframe.contentWindow.postMessage(textureArray);
        },
        unityWatch(e){
            console.log('unityWatch', e)
        }
    },
    components:{
        // Unity
        // Unity
    }
}
</script>

<style scoped>

</style>